import * as React from "react";

const SvgRain = (props) => (
  <svg
    viewBox="0 0 80 68"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.447 54 0 67.334h7.028L11.471 54H4.447ZM19.639 54l-4.444 13.334h7.025L26.667 54h-7.028ZM34.834 54l-4.443 13.334h7.025L41.862 54h-7.028ZM50.029 54l-4.443 13.334h7.024L57.058 54h-7.029ZM65.225 54l-4.444 13.334h7.025L72.253 54h-7.028ZM63.333 14C60.071 6.168 52.347.667 43.333.667c-12.421 0-22.825 8.502-25.794 20h-4.206C5.97 20.667 0 26.637 0 34c0 7.364 5.97 13.334 13.333 13.334h50C72.539 47.334 80 39.873 80 30.667 80 21.461 72.539 14 63.333 14Zm0 26.666h-50a6.675 6.675 0 0 1-6.667-6.667 6.672 6.672 0 0 1 6.667-6.667h10c0-11.048 8.955-20 20-20 7.702 0 13.991 5.853 14.831 13.333h5.169c5.515 0 10 4.486 10 10 0 5.517-4.485 10.001-10 10.001Z"
      fill="#fff"
    />
  </svg>
);

export default SvgRain;
